export const GET_BOOKMARKS = 'bookmarks::GET_BOOKMARKS';
export const GET_BOOKMARKS_REQUEST = 'bookmarks::GET_BOOKMARKS_REQUEST';
export const GET_BOOKMARKS_SUCCESS = 'bookmarks::GET_BOOKMARKS_SUCCESS';
export const GET_BOOKMARKS_FAILURE = 'bookmarks::GET_BOOKMARKS_FAILURE';

export const SET_BOOKMARK = 'bookmarks::SET_BOOKMARK';
export const SET_BOOKMARK_REQUEST = 'bookmarks::SET_BOOKMARK_REQUEST';
export const SET_BOOKMARK_SUCCESS = 'bookmarks::SET_BOOKMARK_SUCCESS';
export const SET_BOOKMARK_FAILURE = 'bookmarks::SET_BOOKMARK_FAILURE';

export const DELETE_ALL_BOOKMARKS = 'bookmarks::DELETE_ALL_BOOKMARKS';
export const DELETE_ALL_BOOKMARKS_REQUEST =
    'bookmarks::DELETE_ALL_BOOKMARKS_REQUEST';
export const DELETE_ALL_BOOKMARKS_SUCCESS =
    'bookmarks::DELETE_ALL_BOOKMARKS_SUCCESS';
export const DELETE_ALL_BOOKMARKS_FAILURE =
    'bookmarks::DELETE_ALL_BOOKMARKS_FAILURE';
